import React from "react";
import Wrapper from "./shared/Wrapper";
import Footer from "./shared/Footer";
import { motion } from "framer-motion";

// Import des composants
import ServicesDisplay from "../components/services/ServicesDisplay";
import ProcessSteps from "../components/services/ProcessSteps";
import FinalCTA from "../components/services/FinalCTA";

export default function Service() {
    return (
        <div className="bg-black text-white overflow-hidden">
            {/* MÊME FOND QUE LA PAGE D'ACCUEIL */}
            {/* Background global avec radial gradient */}
            <div className="fixed inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(16, 211, 81, 0.1),transparent_50%)]" />

            {/* Étoiles animées (20 étoiles) */}
            <div className="fixed inset-0 overflow-hidden z-0">
                {[...Array(20)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-1 h-1 bg-cyan-400/30 rounded-full"
                        initial={{
                            x: Math.random() * 100 + 'vw',
                            y: Math.random() * 100 + 'vh'
                        }}
                        animate={{
                            x: [null, Math.random() * 100 + 'vw'],
                            y: [null, Math.random() * 100 + 'vh']
                        }}
                        transition={{
                            duration: 20 + Math.random() * 10,
                            repeat: Infinity,
                            ease: "linear"
                        }}
                    />
                ))}
            </div>

            <Wrapper>
                {/* ================================================ */}
                {/* SECTION SERVICES DISPLAY */}
                {/* ================================================ */}
                <ServicesDisplay />

                {/* ================================================ */}
                {/* SECTION PROCESS STEPS */}
                {/* ================================================ */}
                <ProcessSteps />

                {/* ================================================ */}
                {/* SECTION FINAL CTA */}
                {/* ================================================ */}
                <FinalCTA />

                {/* ================================================ */}
                {/* FOOTER */}
                {/* ================================================ */}
                <Footer />
            </Wrapper>
        </div>
    );
}
